enum UsersEndpoint {
  ME = '/users/me',
  SOCIAL_PROVIDERS = '/users/me/social_providers',
}

enum SocialProvidersAction {
  LINKED_PROVIDERS = '',
  PROVIDER_LOGIN_URL = '/:provider/login_url',
}

export { UsersEndpoint, SocialProvidersAction };
